<template>
  <div class="d-flex flex-column align-start cell-container pa-0">
    <div v-if="!params.isCopyingConstraints" class="applied-to-description">
      {{ params.value }}
    </div>
    <v-autocomplete
      v-else
      ref="autocompleteSelect"
      v-model="result"
      v-model:search="searchInput"
      data-id-e2e="copyToSelection"
      class="applied-to-description"
      :items="spacebreaksWithGlobal"
      :disabled="!params.data.canConstraintBeCopied"
      :placeholder="tkey('actions.copyTo')"
      item-title="name"
      bg-color="white"
      density="compact"
      width="240px"
      hide-selected
      return-object
      @update:model-value="updateAppliedTo"
      @click:append="menuArrow"
    />
  </div>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { mapState } from 'pinia';

export default {
  setup() {
    const { tkey } = useInternationalization();
    return { tkey };
  },

  data() {
    return {
      valid: true,
      showMenu: false,
      searchInput: '',
      isMapFieldsModalOpen: false,
      uploadMethod: null,
      result: null,
    };
  },

  computed: {
    ...mapState(useAssortmentCanvasStore, [
      'spacebreaks',
      'isConstraintSelectedToCopy',
      'selectedConstraintsToCopy',
    ]),

    spacebreaksWithGlobal() {
      return [
        {
          _id: null,
          name: this.tkey('assortmentCanvasPage.spacebreakSettings.constraints.globalConstraints'),
        },
        ...this.spacebreaks,
      ];
    },
  },

  beforeMount() {
    this.result = this.params.value;
  },

  methods: {
    menuArrow() {
      // allow arrow icon to close autocomplete selection menu
      const autocompleteSelect = this.$refs.autocompleteSelect;
      if (autocompleteSelect.isMenuActive) {
        this.$refs.autocompleteSelect.isMenuActive = false;
        autocompleteSelect.blur();
      } else {
        this.$refs.autocompleteSelect.isMenuActive = true;
        autocompleteSelect.focus();
      }
    },

    updateAppliedTo(update) {
      this.searchInput = '';
      if (this.params.isCopyingConstraints) {
        const { constraintId } = this.params.data;

        this.params.node.setDataValue('appliedTo', update);
        this.selectedConstraintsToCopy[constraintId] = update._id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-container {
  width: 100%;
}

.applied-to-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
</style>
